
import { bestPicFormat } from '@/assets/scripts/utils'

export default {
  name: 'NewsCard',

  props: {
    pic: { type: Object, default: () => ({}) },
    title: { type: String, default: null },
    date: { type: String, default: null },
  },

  created() {
    this.bestPicFormat = bestPicFormat
  },
}
